var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailVerifiedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 485,
    height: 482,
    viewBox: "0 0 485 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53082 173.591V366.371L482.47 362.348V173.631C407.609 118.624 332.747 63.6168 257.885 8.60877C245.596 -0.420988 239.019 -0.137786 226.456 9.09165L2.53082 173.59V173.591Z",
    fill: "#DE6F70",
    stroke: "#DE6F70",
    strokeWidth: 2.66688,
    strokeMiterlimit: 2.61313
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400.28 36.8865H84.7222C79.2951 36.8865 74.8956 41.286 74.8956 46.7131V425.398C74.8956 430.825 79.2951 435.224 84.7222 435.224H400.28C405.707 435.224 410.107 430.825 410.107 425.398V46.7131C410.107 41.286 405.707 36.8865 400.28 36.8865Z",
    fill: "url(#paint0_linear_1343_3480)",
    stroke: "#DE6F70",
    strokeWidth: 0.66624,
    strokeMiterlimit: 2.61313
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.817 82.7419C195.572 89.5435 173.325 122.244 179.251 156.306C184.619 187.169 213.845 215.392 252.688 209.139C284.239 204.06 311.676 173.772 305.761 135.839C300.861 104.421 269.609 76.0228 232.816 82.7419H232.817Z",
    fill: "#53972C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.612 256.499H282.529L282.462 240.636H283.53H154.545L154.612 256.499Z",
    fill: "#BDBFC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.884 158.461L216.569 148.795L205.205 159.715C207.161 161.699 213.623 168.336 218.323 172.9C228.537 182.817 234.698 172.965 244.126 163.535C256.126 151.532 267.984 140.242 279.652 127.947L268.791 116.584L226.886 158.46L226.884 158.461Z",
    fill: "#EFF0F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.594 256.499H330.398L330.455 240.636H298.652L298.594 256.499Z",
    fill: "#BDBFC1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.408 332.888C266.447 336.344 273.538 340.18 279.178 344.469C307.692 366.15 342.423 389.767 369.727 410.895L481.942 479.133C484.253 472.253 482.471 347.142 482.471 328.152V175.52L266.409 332.887L266.408 332.888ZM3.14042 479.134L17.2755 474.473C75.4044 432.299 133.981 387.955 192.007 346.257C196.096 343.318 211.004 331.528 211.558 328.214L2.53083 175.481C2.53083 226.038 2.53083 276.597 2.53083 327.154C2.53083 345.278 0.998663 473.595 3.14042 479.134Z",
    fill: "#FFB5B6",
    stroke: "#DE6F70",
    strokeWidth: 2.66688,
    strokeMiterlimit: 2.61313
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.215 345.847C126.188 387.545 67.6121 431.889 9.48315 474.063L3.14043 479.135H481.941L378.134 402.489C350.828 381.361 316.099 357.744 287.585 336.063C236.07 296.89 250.289 294.588 199.367 334.278C193.317 338.994 187.949 343.165 184.216 345.848L184.215 345.847Z",
    fill: "url(#paint1_linear_1343_3480)",
    stroke: "#DE6F70",
    strokeWidth: 2.66688,
    strokeMiterlimit: 2.61313
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1343_3480",
    x1: 74.8956,
    y1: 236.055,
    x2: 410.106,
    y2: 236.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1343_3480",
    x1: 3.14043,
    y1: 392.355,
    x2: 481.941,
    y2: 392.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB5B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07678"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerifiedIcon);
export default __webpack_public_path__ + "static/media/EmailVerifiedIcon.ce164411bd00f8960f42b3f584ff857c.svg";
export { ForwardRef as ReactComponent };